import React, {Component} from "react";
import {connect} from 'react-redux';
import FJStockVideoHeaderView from "../view/FJStockVideoHeaderView";
import {FJStockVideoAction} from "../../../redux/action/FJRoot.action";


class FJStockVideoHeaderViewContainer extends Component{

	render() {

		let {
			activeOption,
			cutOptionsAction,
			closeStockVideoModalAction
		} = this.props;

		return (
			<FJStockVideoHeaderView activeOption={activeOption}
															cutOptionsAction={cutOptionsAction}
															closeStockVideoModalAction={closeStockVideoModalAction}
			/>
		)
	}

}

const mapStateToProps = function (state) {
	return {
		activeOption: state.stock.activeOption
	}
}

const mapDispatchToProps = function (dispatch) {
	return {
		cutOptionsAction: function (type) {
			dispatch(FJStockVideoAction.setActiveOptionAction(type))
		},
		closeStockVideoModalAction: function () {
			dispatch(FJStockVideoAction.closeStockVideoModalAction())
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(FJStockVideoHeaderViewContainer);